import styled from "styled-components";
import { SolutionColorVariables } from "@smartsuite/types";

export const ActionsLayout = styled.div`
  display: flex;
  align-items: center;
`;

export const ModalContentStyles = styled.div`
  flex-grow: 1;
  background-color: #ffffff;
  padding: 0;
  overflow: auto;
  position: relative;

  h1 {
    color: #5c3aff;
  }
`;

export const EditAutomationContentInnerStyles = styled.div`
  height: 100%;
  position: relative;
  display: flex;
`;

export const EditAutomationSidebarColumnStyles = styled.div<{
  $animateWidth?: boolean;
}>`
  --resizer-left-position: auto;
  --resizer-right-position: -10px;

  position: relative;

  max-width: calc(100% - 520px);
  min-width: 400px;
  height: 100%;

  background: ${SolutionColorVariables.sc2};

  will-change: width;

  ${({ $animateWidth }) =>
    $animateWidth === true
      ? `@media (prefers-reduced-motion: no-preference) {
          transition: width 0.3s ease-out;
        }`
      : ""}
`;

export const EventContentColumnStyles = styled.div.attrs({
  className: "au-settings-panel",
})`
  position: relative;
  flex-grow: 1;
  height: 100%;

  container-type: inline-size;
  container-name: au-settings-panel;
`;

export const EventContentStyles = styled.div`
  height: 100%;
  max-width: 780px;
  margin: 0 auto;
  padding: 30px 20px;
`;

export const StyledTriggerInputsContainer = styled.div`
  opacity: ${(props) => (props.theme.loading === true ? 0.3 : 1)};
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
`;

export const StyledSelectTriggerContainer = styled.div``;

export const StyledErrorText = styled.p`
  position: absolute;
  color: red;
  font-size: 11px;
  margin-top: 50px;
`;

export const HeaderTitle = styled.span`
  white-space: nowrap;
  font-weight: 500;
`;

export const ActionSectionWrapper = styled.div`
  opacity: ${(props) =>
    props.theme.accessError === true ||
    props.theme.integrationDisabled === true ||
    props.theme.actionDisabled === true
      ? 0.3
      : 1};
  user-select: ${(props) =>
    props.theme.accessError === true ||
    props.theme.integrationDisabled === true ||
    props.theme.actionDisabled
      ? "none"
      : "auto"};
  position: relative;
`;

export const SectionHeading = styled.div`
  margin-bottom: 18px;

  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  font-family: inherit;
`;
